import React, { useReducer, useEffect, useRef } from 'react';
import { Section } from '../../Section/Section';
import { SECTION_TYPE } from '../../constants';
import {
    EmailOTPValidationActions,
    EmailOTPValidationInitialStep,
    EmailOTPValidationReducer,
} from './EmailOTPValidationReducer';
import { OTPEmailSummary } from '../../OTPEmailSummary';
import { EmailValidation } from '../../EmailValidation';
import { sendEmailOTP, validateOTP } from 'actions/emailOTPActions';
import { getLanguage } from 'core/i18n';
import { doTagIsValidAndGoNext, doTagModifyEmail } from './tagging';
import { useEmailOTPValidationReset } from 'components/newAccountSteps/initialStep/sections/EmailOTPValidation/hooks/useEmailOTPValidationReset';

export const EmailOTPValidation = ({
    formActions,
    handleModifySection,
    handleValidateSection,
    isCollapsed,
    isValidated,
    preLoaderActions,
    promoCode,
    readyCaptchaToken,
    userProfile,
    userProfileForm,
}) => {
    const [
        {
            isOTPValidated,
            isEmailValidated,
            shouldShowInvalidatedEmailMessage,
            retryOTPCounter,
            errorMessage,
            messageBox,
            snackBar,
        },
        dispatch,
    ] = useReducer(EmailOTPValidationReducer, EmailOTPValidationInitialStep);
    const emailInputRef = useRef();

    useEmailOTPValidationReset({
        emailInputRef,
        dispatch,
        onboardingType: userProfile.onboardingType,
    });

    useEffect(() => {
        isCollapsed && formActions.setValidity('userProfile.email', { required: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCollapsed]);

    const isButtonDisabled = !isOTPValidated;

    const handleClickModifyEmail = () => {
        doTagModifyEmail();
        dispatch({ type: EmailOTPValidationActions.MODIFY_EMAIL });
    };

    const sendEmailOTPCall = async recaptcha => {
        return await sendEmailOTP({
            email: userProfile.email,
            name: userProfile.name,
            language: getLanguage(),
            uuid: userProfile.precontractualDocsId,
            investmentType: userProfile.investmentType,
            recaptcha,
        });
    };

    const validateOTPCall = async otpValue => {
        return await validateOTP({
            email: userProfile.email,
            uuid: userProfile.precontractualDocsId,
            otpValue,
        });
    };

    const onValidateSection = () => {
        if (!isButtonDisabled) {
            doTagIsValidAndGoNext();
            handleValidateSection();
        }
    };

    return (
        <Section
            type={SECTION_TYPE.EMAIL_OTP_VALIDATION}
            handleModifySection={handleModifySection}
            handleValidateSection={onValidateSection}
            isButtonDisabled={!isOTPValidated}
            isCollapsed={isCollapsed}
            isValidated={isValidated}
            userProfile={userProfile}
            promoCode={promoCode}
        >
            {isEmailValidated ? (
                <OTPEmailSummary
                    dispatch={dispatch}
                    email={userProfile.email}
                    errorMessage={errorMessage}
                    handleClickModifyEmail={handleClickModifyEmail}
                    isOTPValidated={isOTPValidated}
                    messageBox={messageBox}
                    preLoaderActions={preLoaderActions}
                    readyCaptchaToken={readyCaptchaToken}
                    retryOTPCounter={retryOTPCounter}
                    sendEmailOTP={sendEmailOTPCall}
                    snackBar={snackBar}
                    validateOTP={validateOTPCall}
                />
            ) : (
                <EmailValidation
                    emailInputRef={emailInputRef}
                    dispatch={dispatch}
                    formActions={formActions}
                    readyCaptchaToken={readyCaptchaToken}
                    sendEmailOTP={sendEmailOTPCall}
                    shouldShowInvalidatedEmailMessage={shouldShowInvalidatedEmailMessage}
                    userProfile={userProfile}
                    userProfileForm={userProfileForm}
                />
            )}
        </Section>
    );
};
